import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToasterService } from '../../../service/common/toaster.service';

import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DialogModule } from 'primeng/dialog';


import { AnalyticsService } from '../../../service/admin/analytics.service';

@Component({
  standalone: true,
  selector: 'app-analytics-collections',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    TableModule,
    ButtonModule,
    CardModule,
    ToggleButtonModule,
    DialogModule
  ],
  providers: [AnalyticsService],
  templateUrl: './analytics-collections.component.html',
  styleUrl: './analytics-collections.component.scss'
})
export class AnalyticsCollectionsComponent {
  filters = {
    start_date: null as any,
    end_date: null as any,
    doctor_id: 1,
    include_free: true
  };

  report: any = {
    summary: {
      total_appointments: 0,
      fees_generated: 0,
      cash_collected: 0,
      online_collected: 0,
      total_collected: 0,
      total_pending: 0
    },

    daily_breakdown: []
  };

  visibleModal: boolean = false;
  dailyDetails: any[] = [];
  selectedDate: string = '';

  constructor(
    private analyticsService: AnalyticsService,
    private toast: ToasterService,
  ) {}

  ngOnInit() {
    this.filters.doctor_id = 1;
  }

  formatDate(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  loadReport() {
    if (!this.filters.start_date || !this.filters.end_date) {

      this.toast.add({
        severity: 'warn',
        summary: 'Invalid',
        detail: 'Select start and end date'
      });

      return;
    }

    const params = {
      start_date: this.formatDate(this.filters.start_date),
      end_date: this.formatDate(this.filters.end_date),
      doctor_id: 1,
      include_free: this.filters.include_free
    };

    this.analyticsService.getCollections(params)
      .subscribe((res: any) => {

        this.report.summary = res.summary;

        this.report.daily_breakdown = res.daily_breakdown;

      }, err => {

        this.toast.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'Could not load collections report'
        });

      });
  }

  openDailyDetails(day: any) {
    this.selectedDate = day.collection_date;

    // later drill-down layer
    this.analyticsService.getDailyPatientDetails({
      date: day.collection_date,
      doctor_id: 1
    }).subscribe((res: any) => {
      this.dailyDetails = res.patients ?? [];
      this.visibleModal = true;
      // console.log("Daily Patients =>", this.dailyDetails);

      }, err => {

      this.dailyDetails = [];
      this.visibleModal = false;

    });
  }

  exportCollections() {

    const params = {
      start_date: this.formatDate(this.filters.start_date),
      end_date: this.formatDate(this.filters.end_date),
      doctor_id: 1,
      // include_free: this.filters.include_free
    };

    this.analyticsService.exportCollections(params)
      .subscribe((blob: Blob) => {

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        const filename = `collections_${params.start_date}_to_${params.end_date}.xlsx`;
        a.download = filename;
        a.click();

        window.URL.revokeObjectURL(url);
      });
  }

  exportDailyPatientDetails(date: string) {

    if (!date) {
      return; // no date = no export
    }

    const params = {
      date: date,
      doctor_id: 1
    };

    this.analyticsService.exportDailyPatientDetails(params)
    .subscribe((blob: Blob) => {

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');

      a.href = url;
      const filename = `daily_patient_details_${date}.xlsx`;
      a.download = filename;
      a.click();

      window.URL.revokeObjectURL(url);
    });
  }
}
